export default __webpack_public_path__ + "static/media/cv.c665f94e.pdf";